






























import Vue from "vue";
import Component from "vue-class-component";
import { Action, State, Getter } from "vuex-class";
import Search from "./Search.vue";

@Component({ components: { Search } })
export default class Table extends Vue {
  @Action("GET_USERS")
  private getUsers!: () => void;

  @Getter("GET_FILTERED") users!: any[];

  constructor() {
    super();
    this.getUsers();
  }
}
